// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { LifeBuoy } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconLifeBuoy(props: any) {
    return <IconBase icon={LifeBuoy} {...props} />
  }

  export default IconLifeBuoy
  